module.exports = __webpack_public_path__ + "img/073621.b4b46af9.png";